<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="3">
          <v-autocomplete
            label="Vendor"
            outlined
            flat
            dense
            background-color="white"
            append-icon="mdi-magnify"
            :items="vendors"
            item-text="supplier_name"
            item-value="id"
            v-model="vendor"
            @change="onChangeVendor"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-autocomplete
            label="Purchase Payment"
            outlined
            flat
            dense
            background-color="white"
            append-icon="mdi-magnify"
            item-text="voucherNumber"
            return-object
            v-model="payment"
            :items="purchasePayments"
            :filter="filterObject"
            @change="addItem"
          >
            <template v-slot:item="data">
              <v-list-item v-on="data.on">
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.voucherNumber"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.invoiceNumber"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:append-outer>
              <v-btn color="primary" @click="mergePayment" v-if="items.length > 1"
                ><v-icon>mdi-content-save</v-icon></v-btn
              >
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items" dense :search="search">
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col cols="12" sm="12" md="9" lg="9">
                <v-text-field
                  flat
                  dense
                  outlined
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.no="{ item }">
          {{ items.map(x => x).indexOf(item) + 1 }}
        </template>
        <template v-slot:item.paymentDate="{ item }">
          {{ formatDate(item.paymentDate) }}
        </template>
        <template v-slot:item.totalAmount="{ item }">
          {{ formatPrice(item.totalAmount) }}
        </template>
        <template v-slot:item.action="{ index }">
          <v-col cols="12" class="text-center">
            <v-btn
              v-if="$rbac.can('payment-merge.delete')"
              color="error"
              @click="deleteItem(index)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("external", ["vendors"]),
  },
  data: () => ({
    items: [],
    payment: null,
    vendor: null,
    purchasePayments: [],
    headers: [
      {
        id: 1,
        text: "No",
        align: "center",
        sortable: false,
        value: "no",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "Date",
        value: "paymentDate",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "Vocher Number",
        value: "voucherNumber",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 4,
        text: "Method",
        value: "methodPayment",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Vendor",
        value: "vendorName",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 6,
        text: "Total",
        value: "totalAmount",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 6,
        text: "INV#",
        value: "invoiceNumber",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 6,
        text: "Action",
        value: "action",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
    search: "",
  }),

  methods: {
    onChangeVendor(val) {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("purchasePayment/getDropdownByVendorId", val)
        .then(response => {
          this.purchasePayments = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatDate(date) {
      return moment(date).format("DD-MM-yyyy");
    },
    async mergePayment() {
      const ids = this.items.map(x => x.id);
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("purchasePayment/mergePurchasePayment", ids)
        .then(response => {
          this.$store.dispatch("toast", {
            type: "success",
            message: "Merge successfully",
          });
          this.$router.push({ name: "Detail Purchase Payment", params: { id: response.data } });
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    // eslint-disable-next-line no-unused-vars
    filterObject(item, queryText, itemText) {
      return (
        item.voucherNumber.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.invoiceNumber.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    async getVendors() {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("external/getVendors")
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    addItem(val) {
      const payment = this.items.find(x => x.id == val.id);
      if (payment) {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Payment ini sudah digunakan",
        });
      } else {
        this.items.push(val);
      }
    },
    deleteItem(index) {
      this.items.splice(index, 1);
    },
  },
  mounted() {
    this.getVendors();
  },
};
</script>

<style></style>
